import ButtonComponent from "@/Inputs/ButtonComponent";
import { Dialog, Transition } from "@headlessui/react";
import { Close } from "@mui/icons-material";
import { Fragment } from "react";

const AddressErrorPopup = ({
    normalAddressError,
    bypass,
    _acceptOrNotAddressOption
}) => {

    return (
        <>
            <Transition appear show={(!!normalAddressError && !bypass)} as={Fragment}>
                <Dialog as="div" className="relative z-[1400]" onClose={() => console.log('close')}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[rgba(0,0,0,0.8)]" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="z-[1400] mx-4 sm:mx-0 w-full max-w-[375px] transform mt-24 p-7 bg-white  text-left align-middle  transition-all rounded-md">
                                    <div>
                                        <Close
                                            className="mb-1 ml-auto cursor-pointer"
                                            onClick={() => _acceptOrNotAddressOption('close')}
                                        />
                                    </div>
                                    <div className="py-4">
                                        <p className="text-t4 mb-0 text-base ">
                                            Address Validation Error - please review the ship address
                                        </p>
                                    </div>

                                    <ButtonComponent classes="primary-button rounded-none w-full mb-0" onClick={() => _acceptOrNotAddressOption('reject')}>
                                        Use same address
                                    </ButtonComponent>

                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

        </>
    );
};
export default AddressErrorPopup;
